/** @file createImage: allocates an RGBA8 image filled with one colour. */
import type { Image, Rgba } from '../types/image';

/** A `width` × `height` image filled with `fill` (default transparent black). */
export function createImage(width: number, height: number, fill?: Rgba): Image {
  const data = new Uint8ClampedArray(width * height * 4);
  if (fill !== undefined && fill.some((c) => c !== 0)) {
    for (let i = 0; i < data.length; i += 4) data.set(fill, i);
  }
  return { width, height, data };
}
